<div class="account-layout">
  <aside class="account-side">
    <div class="account-side-blob account-side-blob-one"></div>
    <div class="account-side-blob account-side-blob-two"></div>

    <a class="account-brand" [routerLink]="[routes.home.url]">
      <span class="account-brand-mark" aria-hidden="true">
        <svg viewBox="0 0 64 64" width="40" height="40">
          <defs>
            <linearGradient id="acctShield" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#8577e0" />
              <stop offset="1" stop-color="#5042a9" />
            </linearGradient>
          </defs>
          <rect width="64" height="64" rx="14" fill="url(#acctShield)" />
          <path d="M32 12 L48 18 V32 C48 42 41 49 32 52 C23 49 16 42 16 32 V18 Z"
            fill="#ffffff" fill-opacity="0.14" stroke="#fbdc70" stroke-width="2"
            stroke-linejoin="round" />
          <path d="M24 32 L30 38 L41 25" fill="none" stroke="#ffffff" stroke-width="4.5"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </span>
      <span class="account-brand-text">
        <span class="account-brand-name">VerifyDeceased</span>
        <span class="account-brand-parent">by LeadCruncher</span>
      </span>
    </a>

    <h2 class="account-side-title">Verify deceased consumers. Eliminate fraud. Protect revenue.</h2>

    <div class="record-illustration">
      <svg class="record-scan" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
          d="M16 6h20l12 12v40a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2Z"
          fill="rgba(255,255,255,0.12)"
          stroke="rgba(255,255,255,0.55)"
          stroke-width="2"
        />
        <path d="M36 6v12h12" stroke="rgba(255,255,255,0.55)" stroke-width="2" stroke-linejoin="round" />
        <path d="M21 28h22M21 36h22M21 44h14" stroke="rgba(255,255,255,0.4)" stroke-width="2" stroke-linecap="round" />
      </svg>

      <div class="record-card">
        <div class="record-card-head">
          <span class="record-name">Jane A. Doe</span>
          <span class="record-badge">Verified</span>
        </div>
        <div class="record-fields">
          <div class="record-field">
            <span class="record-label">DOB</span>
            <span class="record-value">04 / 12 / 1948</span>
          </div>
          <div class="record-field">
            <span class="record-label">Date of death</span>
            <span class="record-value">21 / 09 / 2025</span>
          </div>
          <div class="record-field">
            <span class="record-label">Age</span>
            <span class="record-value">77</span>
          </div>
          <div class="record-field">
            <span class="record-label">Location</span>
            <span class="record-value">Austin, TX</span>
          </div>
        </div>
      </div>
    </div>

    <ul class="account-highlights">
      @for (item of highlights; track item) {
        <li>{{ item }}</li>
      }
    </ul>
  </aside>

  <section class="account-main">
    <div class="account-main-inner">
      <a class="back-home" [routerLink]="[routes.home.url]">
        <span class="back-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 6L9 12L15 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span class="back-text">Back to Home</span>
      </a>

      <div class="account-card">
        <header class="account-card-head">
          <h1>{{ title() }}</h1>
          @if (subtitle()) {
            <p>{{ subtitle() }}</p>
          }
        </header>

        <ng-content></ng-content>
      </div>
    </div>
  </section>
</div>
